export const emailRoute = {
  EMAIL_LIST: '/email/list',
  // EMAIL_SETTING: '/setting/email'
};
